import { compose } from "redux";
import React, { PureComponent } from "react";
import { Typography } from "@material-ui/core";

import Link from "app/components/Link";
import config from "infrastructure/config";

class SpecificationLinkField extends PureComponent {
  render() {
    const { input, children } = this.props;
    const { value: specificationId } = input;

    if (!specificationId)
      return <Typography>No requirements configured yet</Typography>;

    return (
      <Link
        external
        target="_blank"
        href={`${config.competencyClientUrl}/hr-portal/specifications/${specificationId}/courses`}
      >
        {children}
      </Link>
    );
  }
}

export default compose()(SpecificationLinkField);
